import { render, staticRenderFns } from "./TrashRetentionSettings.vue?vue&type=template&id=5d41c127"
import script from "./TrashRetentionSettings.vue?vue&type=script&lang=js"
export * from "./TrashRetentionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports